var map = {
	"./general/DocsIcon--bluecheckmark.svg": 2263,
	"./general/DocsIcon--country.svg": 2264,
	"./general/DocsIcon--github.svg": 2265,
	"./general/DocsIcon--guide.svg": 2266,
	"./general/DocsIcon--list.svg": 2267,
	"./general/DocsIcon--locale.svg": 2268,
	"./general/DocsIcon--thumbsdown.svg": 2269,
	"./general/DocsIcon--thumbsup.svg": 2270,
	"./general/DocsIcon--video.svg": 2271,
	"./nav/DocsIcon--account.svg": 2272,
	"./nav/DocsIcon--business.svg": 2273,
	"./nav/DocsIcon--developertools.svg": 2274,
	"./nav/DocsIcon--financialservices.svg": 2275,
	"./nav/DocsIcon--home.svg": 2276,
	"./nav/DocsIcon--mobilenav.svg": 2277,
	"./nav/DocsIcon--payments.svg": 2278,
	"./nav/DocsIcon--reference.svg": 2279,
	"./nav/DocsIcon--security.svg": 2280,
	"./product/DocsIcon--account.svg": 2281,
	"./product/DocsIcon--atlas.svg": 2282,
	"./product/DocsIcon--capital.svg": 2283,
	"./product/DocsIcon--checkout.svg": 2284,
	"./product/DocsIcon--climate.svg": 2285,
	"./product/DocsIcon--connect.svg": 2286,
	"./product/DocsIcon--corporatecard.svg": 2287,
	"./product/DocsIcon--dashboard.svg": 2288,
	"./product/DocsIcon--developertools.svg": 2289,
	"./product/DocsIcon--elements.svg": 2290,
	"./product/DocsIcon--gateddocs.svg": 2291,
	"./product/DocsIcon--identity.svg": 2292,
	"./product/DocsIcon--implementationguides.svg": 2293,
	"./product/DocsIcon--invoicing.svg": 2294,
	"./product/DocsIcon--issuing.svg": 2295,
	"./product/DocsIcon--partners.svg": 2296,
	"./product/DocsIcon--payments.svg": 2297,
	"./product/DocsIcon--radar.svg": 2298,
	"./product/DocsIcon--reporting.svg": 2299,
	"./product/DocsIcon--sigma.svg": 2300,
	"./product/DocsIcon--styleguide.svg": 2301,
	"./product/DocsIcon--tax.svg": 2302,
	"./product/DocsIcon--terminal.svg": 2303,
	"./product/DocsIcon--treasury.svg": 2304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2262;